// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3q3Vy","itemTitle":"ClientEmergencyInfo_itemTitle__gFzJc","itemText":"ClientEmergencyInfo_itemText__1ZvYo"};